import { render, staticRenderFns } from "./coupon-layer.vue?vue&type=template&id=38ea5e0a&scoped=true&lang=pug&"
import script from "./coupon-layer.vue?vue&type=script&lang=js&"
export * from "./coupon-layer.vue?vue&type=script&lang=js&"
import style0 from "./coupon-layer.vue?vue&type=style&index=0&id=38ea5e0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea5e0a",
  null
  
)

export default component.exports